import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useStateValue } from "../../StateProvider";
import { getCartTotal } from "../../reducer";
import { CheckCircle } from "lucide-react";
import { useTitle } from "../../hooks/useTitle";
import "./ThankYou.css";

function ThankYou() {
  useTitle("Thank You - TrendBay DS");
  const [{ cart, user }, dispatch] = useStateValue();
  const firstName = user
    ? (user.displayName || user.name || "").split(" ")[0] || null
    : null;
  const navigate = useNavigate();
  const [orderReference, setOrderReference] = useState("");
  const shippingInfo = JSON.parse(localStorage.getItem("shippingInfo") || "{}");
  const billingInfo = JSON.parse(localStorage.getItem("billingInfo") || "{}");

  useEffect(() => {
    if (!shippingInfo) navigate("/");
  }, [shippingInfo, navigate]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const reference = params.get("reference");
    if (reference) {
      setOrderReference(reference);
    } else {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    return () => {
      dispatch({ type: "CLEAR_CART" });
    };
  }, [dispatch]);

  return (
    <div className="ty-page">
      <div className="ty-wrap">
        {/* Success icon + heading */}
        <div className="ty-icon">
          <CheckCircle size={64} color="#00A855" strokeWidth={1.8} />
        </div>
        <h1 className="ty-title">
          {firstName ? `Thank you, ${firstName}!` : "Thank you!"}
        </h1>
        {orderReference && (
          <p className="ty-ref">Reference #{orderReference}</p>
        )}
        <p className="ty-sub">
          Your order is confirmed. You'll receive a confirmation email shortly.
        </p>

        {/* Shipping info card */}
        {shippingInfo && (shippingInfo.fullName || shippingInfo.email) && (
          <div className="ty-card">
            <h2 className="ty-card__title">Shipping Information</h2>
            {shippingInfo.email && (
              <p className="ty-card__row">{shippingInfo.email}</p>
            )}
            {shippingInfo.phoneNumber && (
              <p className="ty-card__row">{shippingInfo.phoneNumber}</p>
            )}
            {shippingInfo.fullName && (
              <p className="ty-card__row">{shippingInfo.fullName}</p>
            )}
            {shippingInfo.address && (
              <p className="ty-card__row">{shippingInfo.address}</p>
            )}
            {(shippingInfo.city || shippingInfo.state) && (
              <p className="ty-card__row">
                {[shippingInfo.city, shippingInfo.state]
                  .filter(Boolean)
                  .join(", ")}
              </p>
            )}
            {shippingInfo.country && (
              <p className="ty-card__row">{shippingInfo.country}</p>
            )}
          </div>
        )}

        {/* Billing info card */}
        {billingInfo && billingInfo.fullName && (
          <div className="ty-card">
            <h2 className="ty-card__title">Billing Information</h2>
            {billingInfo.fullName && (
              <p className="ty-card__row">{billingInfo.fullName}</p>
            )}
            {billingInfo.address && (
              <p className="ty-card__row">{billingInfo.address}</p>
            )}
            {(billingInfo.city || billingInfo.state) && (
              <p className="ty-card__row">
                {[billingInfo.city, billingInfo.state]
                  .filter(Boolean)
                  .join(", ")}
              </p>
            )}
            {billingInfo.country && (
              <p className="ty-card__row">{billingInfo.country}</p>
            )}
          </div>
        )}

        {/* CTAs */}
        <Link to="/orders" className="ty-btn">
          View My Orders
        </Link>
        <Link to="/" className="ty-link">
          Continue Shopping
        </Link>
      </div>
    </div>
  );
}

export default ThankYou;
